export let props = ['value', 'props','datatype','placeholder','enable', 'isAll', 'type', 'width']
export let model = {
  options: [
    // {
    //   id: '123',
    //   pid: null,
    //   label: '广西交通投资集团',
    //   type: '公司',
    //   children: [
    //     {
    //       id: '321',
    //       pid: '123',
    //       label: '钦州公司',
    //       type: '公司'
    //     }
    //   ]
    // }
  ],
  nodes:{},
  // props: {
  //   value: 'organizationId',
  //   label: 'organizationName'
  // }
}
export let computed = {
  current: {
    get () {
      return this.value
    },
    set (val) {
      // console.log(val)
      // val是选中的节点对象
      this.$emit('input', val)
    }
  }
}
